// Путь: D:\QR\QR-WEB\dashboard\src\components\Landing\DaryLanding.jsx
// Название: DARY Landing Page
// Версия: 2.1
// Дата: 12.12.2025 15:35

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DaryLanding.css';

const DaryLanding = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole');
    
    if (token && role) {
      if (role === 'admin') {
        navigate('/admin/dashboard');
      } else if (role === 'business') {
        navigate('/business/dashboard');
      } else {
        navigate('/dashboard');
      }
    }
  }, [navigate]);

  return (
    <div className="landing-container">
      {/* Левая панель - информация */}
      <div className="landing-left">
        <div className="landing-logo-section">
          <div className="landing-gift-icon">🎁</div>
          <h1 className="landing-title">DARY</h1>
          <p className="landing-subtitle">DIGITAL ASSET REWARD YOURS</p>
        </div>

        <h2 className="landing-headline">Цифровые подарки нового поколения</h2>
        <p className="landing-description">
          Дарите цифровые подарки — красиво, безопасно и мгновенно
        </p>

        <div className="landing-features">
          <div className="feature-item">
            <span className="feature-icon">💎</span>
            <div>
              <strong>Цифровые подарки</strong>
              <p>Создавайте красивые цифровые подарки</p>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔒</span>
            <div>
              <strong>Безопасно</strong>
              <p>Стеганография защищает ваши средства</p>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">⚡</span>
            <div>
              <strong>Мгновенно</strong>
              <p>Отправка и получение за секунды</p>
            </div>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🎨</span>
            <div>
              <strong>Красиво</strong>
              <p>18 тематических дизайнов на любой повод</p>
            </div>
          </div>
        </div>
      </div>

      {/* Правая панель - действия */}
      <div className="landing-right">
        <div className="landing-card">
          <h2>Добро пожаловать!</h2>
          <p className="landing-card-subtitle">Выберите действие</p>

          <button 
            className="landing-btn-primary"
            onClick={() => navigate('/claim')}
          >
            <span className="btn-icon">🎁</span>
            <div className="btn-content">
              <strong>Получить подарок</strong>
              <small>Загрузите открытку или введите код</small>
            </div>
          </button>

          <div className="landing-divider">
            <span>или</span>
          </div>

          <button 
            className="landing-btn-secondary"
            onClick={() => navigate('/login')}
          >
            🔑 Войти в аккаунт
          </button>

          <button 
            className="landing-btn-outline"
            onClick={() => navigate('/register')}
          >
            ✨ Создать аккаунт
          </button>

          {/* Кнопки магазинов */}
          <div className="landing-stores">
            <a 
              href="https://play.google.com/store/apps/details?id=com.dary.app" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-btn"
            >
              <svg className="store-icon" viewBox="0 0 24 24" width="24" height="24">
                <path fill="#4285F4" d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92z"/>
                <path fill="#34A853" d="M16.296 15.262l-2.504-2.504L3.609 22.186c.32.154.691.154 1.012 0l11.675-6.924z"/>
                <path fill="#FBBC04" d="M20.015 10.295l-3.72-2.207-2.503 2.504 2.503 2.504 3.72-2.207c.604-.359.604-1.235 0-1.594z"/>
                <path fill="#EA4335" d="M3.609 1.814l10.183 10.183 2.504-2.504L4.621.569a.997.997 0 0 0-1.012 0 .996.996 0 0 0-.609.92z"/>
              </svg>
              <div className="store-text">
                <small>Скачать в</small>
                <strong>Google Play</strong>
              </div>
            </a>

            <a 
              href="https://apps.apple.com/app/dary/id0000000000" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-btn"
            >
              <svg className="store-icon" viewBox="0 0 24 24" width="24" height="24">
                <path fill="#000" d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="store-text">
                <small>Скачать в</small>
                <strong>App Store</strong>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DaryLanding;